import Vue from 'vue'
import _ from 'lodash'

Vue.filter('userName', function(user) {
  // console.log('filter: user :>> ', user);
  if (!user) { return '' }
  if (_.isString(user)) {
    return user
  }
  if (user.full_name) {
    return user.full_name
  }
  if (user.name) {
    return user.name
  }
  var name = ''
  if (user.first_name) {
    name = user.first_name
  }
  if (user.last_name) {
    if (name) {
      name += ' '
    }
    name += user.last_name
  }
  if (!name) {
    name = user.name
  }
  if (!name) {
    name = user.username
  }
  return name
})

export function userWorkInfo(user) {
  if (!user) {
    return ''
  }

  if (user.job_title && user.organization) {
    let translate = null

    if (Vue.prototype && Vue.prototype.$i18n && typeof Vue.prototype.$i18n.t === 'function') {
      translate = Vue.prototype.$i18n.t.bind(Vue.prototype.$i18n)
    }

    if (!translate) {
      try {
        const appI18n = require('@/i18n').default
        if (appI18n && typeof appI18n.t === 'function') {
          translate = appI18n.t.bind(appI18n)
        }
      } catch (error) {
        translate = null
      }
    }

    if (!translate) {
      return `${user.job_title}, ${user.organization}`
    }

    return translate('user.work.information', {
      job_title: user.job_title,
      organization: user.organization,
    })
  }

  return user.job_title || user.organization || ''
}

Vue.filter('userWorkInfo', userWorkInfo)

export default {}
